/**
 * 认证错误处理工具函数
 */
/**
 * 应该触发自动登出的错误码列表
 * 基于项目中实际的错误码定义
 */
const LOGOUT_ERROR_CODES = [
    // HTTP状态码相关
    'UNAUTHORIZED',
    'INVALID_TOKEN',
    'TOKEN_EXPIRED',
    'INVALID_REFRESH_TOKEN',
    'TOKEN_VERIFICATION_FAILED',
    'USER_NOT_FOUND',
    // 业务逻辑错误
    'MISSING_TOKEN',
    // Supabase特定错误
    'INVALID_CREDENTIALS',
    'SESSION_EXPIRED',
];
/**
 * 检查错误是否应该触发自动登出
 * @param error 任意类型的错误对象
 * @returns 是否应该触发登出
 */
export function shouldTriggerLogout(error) {
    // 1. 检查HTTP 401状态码
    if (typeof error === 'object' &&
        error !== null &&
        'response' in error &&
        typeof error.response === 'object' &&
        error.response !== null &&
        'status' in error.response &&
        error.response.status === 401) {
        return true;
    }
    // 2. 检查业务错误码
    if (typeof error === 'object' &&
        error !== null &&
        'code' in error &&
        typeof error.code === 'string') {
        const errorCode = error.code;
        return LOGOUT_ERROR_CODES.includes(errorCode);
    }
    // 3. 检查嵌套在response中的错误码
    if (typeof error === 'object' &&
        error !== null &&
        'response' in error &&
        typeof error.response === 'object' &&
        error.response !== null &&
        'code' in error.response &&
        typeof error.response.code === 'string') {
        const errorCode = error.response.code;
        return LOGOUT_ERROR_CODES.includes(errorCode);
    }
    return false;
}
/**
 * 导出错误码列表供其他地方使用
 */
export { LOGOUT_ERROR_CODES };
//# sourceMappingURL=errorHelpers.js.map